export const updatePurchaseReturnList = (state, payload) => {
  state.purchaseReturnList = payload
}

export const fetchPurchaseReturnInfo = (state, payload) => {
  state.purchaseReturnInfo = payload
}

export const fetchUnClosedPurchaseReturnCount = (state, payload) => {
  state.unClosedPurchaseReturnCount = payload
}

export const fetchUnPaidPurchaseReturnCount = (state, payload) => {
  state.unPaidPurchaseReturnCount = payload
}
